enum PricingPlan {
    FREEMIUM = 'freemium',
    PREMIUM = 'premium',
  }

export default PricingPlan;
